export default __webpack_public_path__ + "static/downloadqr-27c73521ab6de2947a9faeadd675ae7a.svg";